import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_specific_tenant_sales_rep_budget_allocation_details: { message: "idle" },
};

export const retrieve_specific_tenant_sales_rep_budget_allocation_details_Slice = createSlice({
 name: "retrieve_specific_tenant_sales_rep_budget_allocation_details",
 initialState,
 reducers: {
  success_retrieve_specific_tenant_sales_rep_budget_allocation_details: (state, action) => {
   state.retrieve_specific_tenant_sales_rep_budget_allocation_details = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_specific_tenant_sales_rep_budget_allocation_details: (state, action) => {
   state.retrieve_specific_tenant_sales_rep_budget_allocation_details = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_specific_tenant_sales_rep_budget_allocation_details: (state) => {
   state.retrieve_specific_tenant_sales_rep_budget_allocation_details = { status: app_consts.IDLE };
  },
  loading_retrieve_specific_tenant_sales_rep_budget_allocation_details: (state) => {
   state.retrieve_specific_tenant_sales_rep_budget_allocation_details = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_specific_tenant_sales_rep_budget_allocation_details, fail_retrieve_specific_tenant_sales_rep_budget_allocation_details, reset_retrieve_specific_tenant_sales_rep_budget_allocation_details, loading_retrieve_specific_tenant_sales_rep_budget_allocation_details } = retrieve_specific_tenant_sales_rep_budget_allocation_details_Slice.actions;

export default retrieve_specific_tenant_sales_rep_budget_allocation_details_Slice.reducer;